import { render, staticRenderFns } from "./dropdowns.vue?vue&type=template&id=1ec2813b&scoped=true&"
import script from "./dropdowns.vue?vue&type=script&lang=js&"
export * from "./dropdowns.vue?vue&type=script&lang=js&"
import style0 from "./dropdowns.vue?vue&type=style&index=0&id=1ec2813b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2813b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec2813b')) {
      api.createRecord('1ec2813b', component.options)
    } else {
      api.reload('1ec2813b', component.options)
    }
    module.hot.accept("./dropdowns.vue?vue&type=template&id=1ec2813b&scoped=true&", function () {
      api.rerender('1ec2813b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/subcomponents/dropdowns.vue"
export default component.exports